<template>
    <el-container style="height: 100%">
        <el-header style="height: 30px">
            <van-nav-bar title="未支付金额" left-text="返回" left-arrow @click-left="historyBackPath('intebotab')"/>
        </el-header>
        <el-main style="height: 100%">
            <el-form :inline="true" :model="searchParms" size="mini">
                <el-form-item label="品牌门店">
                    <el-cascader :options="storeData" filterable clearable v-model="searchParms.storeStructs" :props="{ checkStrictly: true }" size="mini" style="width: 100%" @change="storeChange"></el-cascader>
                </el-form-item>
            </el-form>
            <el-table height="calc(100% - 4rem)" border :data="inteboNotPayData" size="mini" style="text-align: center" highlight-current-row>
                <el-table-column label="门店"  align="center" prop="storename">
                    <template slot-scope="scope">
                        {{scope.row.parentname}}/{{scope.row.storename}}
                    </template>
                </el-table-column>
                <el-table-column label="SN码"  align="center" prop="sn"></el-table-column>
                <el-table-column label="仪器型号"  align="center" prop="yqmodel"></el-table-column>
                <el-table-column label="支付名称"  align="center" prop="payname"></el-table-column>
                <el-table-column label="待支付"  align="center" prop="payamout"></el-table-column>
                <el-table-column label="剩余期数"  align="center" prop="restfq"></el-table-column>
                <el-table-column label="剩余金额"  align="center" prop="devicerestamount"></el-table-column>
                <el-table-column label="操作"  align="center" width="100" fixed="right">
                    <template slot-scope="scope">
                        <el-button @click="openPay(scope)" type="text" size="small">支付</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-main>
        <el-dialog title="支付" :visible.sync="dialogVisible" width="100%" top="0px" class="notpay" :close-on-click-modal="false">
            <el-form :model="inteboPayInfo" size="mini" label-width="80px">
                <el-form-item label="门店">
                    {{inteboPayInfo.parentname}}/{{inteboPayInfo.storename}}
                </el-form-item>
                <el-form-item label="SN">
                    {{inteboPayInfo.sn}}
                </el-form-item>
                <el-form-item label="仪器型号">
                    {{inteboPayInfo.yqmodel}}
                </el-form-item>
                <el-form-item label="待付">
                    {{inteboPayInfo.payamout}}
                </el-form-item>
                <el-form-item label="支付日期">
                    <el-date-picker size="mini" :editable="false" style="width: 100%" v-model="inteboPayInfo.paydate" type="date" placeholder="开始日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="实付金额">
                    <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="inteboPayInfo.realpayamount" @change="numberChange">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="剩余金额">
                    {{inteboPayInfo.restamount}}
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
                <el-button type="primary" :loading="queryLoadBtton" size="mini" @click="realInteboPayInfo()">保存</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>
<script>
export default {
    data() {
        return {
            queryLoadBtton:false,
            curIndex:0,
            inteboPayInfo:{
                parentid:"",
                storeid:"",
                parentname:"",
                storename:"",
                sn:"",
                yqmodel:"",
                payname:"",
                payamout:0,
                realpayamount:0,
                restamount:0,
                paydate:"",
            },
            dialogVisible:false,
            storeData:[],
            inteboNotPayData:[],
            searchParms:{
                parentid:"",
                storeid:"",
            },
        }
    },
    created() {
        this.getInteboStoreStructs();
        this.getInteboPayInfoByStatus();
    },
    methods:{
        numberChange(){
            this.inteboPayInfo.restamount=this.$asNumber(this.inteboPayInfo.payamout)-this.$asNumber(this.inteboPayInfo.realpayamount);
        },
        realInteboPayInfo(){
            this.queryLoadBtton=true;
            this.$postw("intebosale/realInteboPayInfo",this.inteboPayInfo).then(res=>{
                this.getInteboPayInfoByStatus();
                this.$message({message: "保存成功", type: 'success'});
                this.dialogVisible=false;
                this.queryLoadBtton=false;
            });
        },
        openPay(scope){
            this.dialogVisible=true;
            this.curIndex=scope.$index;
            this.inteboPayInfo=scope.row;
            this.inteboPayInfo.realpayamount=this.inteboPayInfo.payamout;
        },
        storeChange(val){
            this.searchParms.parentid="";
            this.searchParms.storeid="";
            if(val[1]){
                this.searchParms.parentid=val[0];
                this.searchParms.storeid=val[1];
            }
            else{
                if(val[0]){
                    this.searchParms.parentid=val[0];
                }
            }
            this.getInteboPayInfoByStatus();
        },
        getInteboPayInfoByStatus(){
            this.$post("intebosale/getInteboPayInfoByStatus",{parentid: this.searchParms.parentid,storeid:this.searchParms.storeid}).then(res=>{
                this.inteboNotPayData=res.object;
            });
        },
        getInteboStoreStructs(){
            this.$post("inteboStore/getInteboStoreStructs").then(res=>{
                if(res.sucess){
                    this.storeData=res.object;
                }
            });
        }
    }
}
</script>
<style lang="scss" rel="stylesheet/scss">
.notpay .el-input-number .el-input__inner {
    text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/page/intebo/intebotab/notpay.vue